<script setup>
import { computed, watch } from 'vue';
import PFBaseModal from "@/components/common/modal/PFBaseModal.vue";
import { useModalProvider } from "@/composables/useModalProvider";
import { useStore } from 'vuex';

const { openModal, isModalOpen, closeModal } = useModalProvider();
const store = useStore();

const showModal = computed(() => store.state.partnerProfile.showCongratulationsModal);
watch(showModal, (newVal) => {
  newVal ? openModal() : closeModal();  
});

</script>

<template>

  <PFBaseModal v-if="isModalOpen" :modalHeaderText="$t('progress.modal.completed.title') " >
    <div class="flex justify-center">
      <img src='../../assets/Checklist.svg' alt="congratulations modal image" width="180" height="180"  />
    </div>

    <div class="body-s-size mt-6">
      {{$t('progress.modal.completed.text')}}
    </div>
  </PFBaseModal>

</template> 
 